export default {
    categories:     { method: 'get',    url: 'categories' },
    createCategory: { method: 'post',   url: 'categories'},
    updateCategory: { method: 'put',    url: 'categories/{id}'},
    deleteCategory: { method: 'delete', url: 'categories/{id}'}
}